export const SOCIAL_LINKS_FEATURE_KEY = 'social-links';
